import React from 'react'

const NotFoundSiteManaged = () => <div>管理している現場がありません</div>

export default NotFoundSiteManaged
